import { c as _c } from "react/compiler-runtime";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { BrandCardHeader } from "../brand/BrandCardHeader";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { LoadingButton } from "../ui/loading-button";
import { StatusMessage } from "../ui/status-message";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PasswordInput(t0) {
  const $ = _c(21);
  const {
    id,
    label,
    value,
    onChange,
    showPassword,
    onTogglePassword
  } = t0;
  let t1;
  if ($[0] !== id || $[1] !== label) {
    t1 = /*#__PURE__*/_jsx("label", {
      htmlFor: id,
      className: "block text-sm font-medium",
      children: label
    });
    $[0] = id;
    $[1] = label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = showPassword ? "text" : "password";
  let t3;
  if ($[3] !== onChange) {
    t3 = e => onChange(e.target.value);
    $[3] = onChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== id || $[6] !== t2 || $[7] !== t3 || $[8] !== value) {
    t4 = /*#__PURE__*/_jsx(Input, {
      id: id,
      name: id,
      type: t2,
      value: value,
      onChange: t3,
      required: true
    });
    $[5] = id;
    $[6] = t2;
    $[7] = t3;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== showPassword) {
    t5 = showPassword ? /*#__PURE__*/_jsx(EyeOff, {
      className: "h-4 w-4 text-gray-400"
    }) : /*#__PURE__*/_jsx(Eye, {
      className: "h-4 w-4 text-gray-400"
    });
    $[10] = showPassword;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onTogglePassword || $[13] !== t5) {
    t6 = /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: onTogglePassword,
      className: "absolute inset-y-0 right-0 flex items-center pr-3",
      children: t5
    });
    $[12] = onTogglePassword;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = /*#__PURE__*/_jsxs("div", {
      className: "relative",
      children: [t4, t6]
    });
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t7) {
    t8 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [t1, t7]
    });
    $[18] = t1;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function ResetPasswordForm(t0) {
  const $ = _c(50);
  const {
    onSubmit,
    onBackToSignIn,
    loading,
    statusMessage,
    onStatusMessageAction,
    statusMessageActionLabel: t1
  } = t0;
  const statusMessageActionLabel = t1 === undefined ? "Continue" : t1;
  const [showPassword, setShowPassword] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      password: "",
      confirmPassword: ""
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [formData, setFormData] = useState(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      message: "",
      success: false
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const [formState, setFormState] = useState(t3);
  let t4;
  if ($[2] !== formData.confirmPassword || $[3] !== formData.password) {
    t4 = () => {
      if (formData.password !== formData.confirmPassword) {
        return {
          success: false,
          message: "Passwords do not match"
        };
      }
      return {
        success: true,
        message: ""
      };
    };
    $[2] = formData.confirmPassword;
    $[3] = formData.password;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const validatePasswords = t4;
  let t5;
  if ($[5] !== formData.password || $[6] !== onSubmit || $[7] !== validatePasswords) {
    t5 = async e => {
      e.preventDefault();
      const validation = validatePasswords();
      if (!validation.success) {
        setFormState(validation);
        return;
      }
      ;
      try {
        const response = await onSubmit(formData.password);
        setFormState({
          success: response.success,
          message: response.message
        });
      } catch (t6) {
        const error = t6;
        setFormState({
          success: false,
          message: error instanceof Error ? error.message : "An error occurred"
        });
      }
    };
    $[5] = formData.password;
    $[6] = onSubmit;
    $[7] = validatePasswords;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleSubmit = t5;
  if (statusMessage && onStatusMessageAction) {
    let t6;
    if ($[9] !== statusMessage.message || $[10] !== statusMessage.variant) {
      t6 = /*#__PURE__*/_jsx(StatusMessage, {
        message: statusMessage.message,
        variant: statusMessage.variant
      });
      $[9] = statusMessage.message;
      $[10] = statusMessage.variant;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== onStatusMessageAction || $[13] !== statusMessageActionLabel) {
      t7 = /*#__PURE__*/_jsx(Button, {
        onClick: onStatusMessageAction,
        className: "w-full",
        children: statusMessageActionLabel
      });
      $[12] = onStatusMessageAction;
      $[13] = statusMessageActionLabel;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== t6 || $[16] !== t7) {
      t8 = /*#__PURE__*/_jsxs("div", {
        className: "space-y-4",
        children: [t6, t7]
      });
      $[15] = t6;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    return t8;
  }
  let t6;
  if ($[18] !== formData) {
    t6 = value => setFormData({
      ...formData,
      password: value
    });
    $[18] = formData;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== showPassword) {
    t7 = () => setShowPassword(!showPassword);
    $[20] = showPassword;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== formData.password || $[23] !== showPassword || $[24] !== t6 || $[25] !== t7) {
    t8 = /*#__PURE__*/_jsx(PasswordInput, {
      id: "password",
      label: "Nytt l\xF6senord",
      value: formData.password,
      onChange: t6,
      showPassword: showPassword,
      onTogglePassword: t7
    });
    $[22] = formData.password;
    $[23] = showPassword;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== formData) {
    t9 = value_0 => setFormData({
      ...formData,
      confirmPassword: value_0
    });
    $[27] = formData;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== showPassword) {
    t10 = () => setShowPassword(!showPassword);
    $[29] = showPassword;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== formData.confirmPassword || $[32] !== showPassword || $[33] !== t10 || $[34] !== t9) {
    t11 = /*#__PURE__*/_jsx(PasswordInput, {
      id: "confirmPassword",
      label: "Bekr\xE4fta nytt l\xF6senord",
      value: formData.confirmPassword,
      onChange: t9,
      showPassword: showPassword,
      onTogglePassword: t10
    });
    $[31] = formData.confirmPassword;
    $[32] = showPassword;
    $[33] = t10;
    $[34] = t9;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== loading) {
    t12 = /*#__PURE__*/_jsx(LoadingButton, {
      type: "submit",
      className: "w-full",
      loading: loading,
      children: "\xC5terst\xE4ll l\xF6senord"
    });
    $[36] = loading;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== formState.message || $[39] !== formState.success) {
    t13 = formState.message && /*#__PURE__*/_jsx(StatusMessage, {
      message: formState.message,
      variant: formState.success ? "success" : "error"
    });
    $[38] = formState.message;
    $[39] = formState.success;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== onBackToSignIn) {
    t14 = /*#__PURE__*/_jsx(Button, {
      type: "button",
      variant: "outline",
      className: "w-full",
      onClick: onBackToSignIn,
      children: "Tillbaka till inloggning"
    });
    $[41] = onBackToSignIn;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== handleSubmit || $[44] !== t11 || $[45] !== t12 || $[46] !== t13 || $[47] !== t14 || $[48] !== t8) {
    t15 = /*#__PURE__*/_jsxs("form", {
      onSubmit: handleSubmit,
      className: "space-y-4",
      children: [t8, t11, t12, t13, t14]
    });
    $[43] = handleSubmit;
    $[44] = t11;
    $[45] = t12;
    $[46] = t13;
    $[47] = t14;
    $[48] = t8;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  return t15;
}
export default function ResetPasswordCard(t0) {
  const $ = _c(9);
  const {
    onSubmit,
    onBackToSignIn,
    loading,
    isValidating,
    statusMessage,
    onStatusMessageAction,
    statusMessageActionLabel
  } = t0;
  if (isValidating) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /*#__PURE__*/_jsx(Card, {
        className: "bg-card m-auto w-screen overflow-y-auto rounded-none shadow-none sm:max-h-[calc(100vh-112px)] sm:max-w-md sm:rounded-lg sm:shadow-lg sm:shadow-zinc-500/10",
        children: /*#__PURE__*/_jsx(CardContent, {
          className: "flex min-h-[400px] items-center justify-center p-6",
          children: /*#__PURE__*/_jsx("div", {
            className: "text-muted-foreground text-center text-sm",
            children: "Validerar \xE5terst\xE4llningsl\xE4nk..."
          })
        })
      });
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(BrandCardHeader, {
      title: "\xC5terst\xE4ll l\xF6senord",
      subtitle: "Ange ditt nya l\xF6senord nedan"
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== loading || $[3] !== onBackToSignIn || $[4] !== onStatusMessageAction || $[5] !== onSubmit || $[6] !== statusMessage || $[7] !== statusMessageActionLabel) {
    t2 = /*#__PURE__*/_jsxs(Card, {
      className: "bg-card m-auto w-screen overflow-y-auto rounded-none shadow-none sm:max-h-[calc(100vh-112px)] sm:max-w-md sm:rounded-lg sm:shadow-lg sm:shadow-zinc-500/10",
      children: [t1, /*#__PURE__*/_jsx(CardContent, {
        className: "p-6",
        children: /*#__PURE__*/_jsx(ResetPasswordForm, {
          onSubmit: onSubmit,
          onBackToSignIn: onBackToSignIn,
          loading: loading,
          statusMessage: statusMessage,
          onStatusMessageAction: onStatusMessageAction,
          statusMessageActionLabel: statusMessageActionLabel
        })
      })]
    });
    $[2] = loading;
    $[3] = onBackToSignIn;
    $[4] = onStatusMessageAction;
    $[5] = onSubmit;
    $[6] = statusMessage;
    $[7] = statusMessageActionLabel;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}